// Encabezado del análisis (título + subtítulo).
// Equivalente a las líneas de load() que escriben #title/#sub en el
// original (public/cabrillo/src/plantilla.html:83-84). No depende de
// cur/bf: solo cambia cuando se carga un log nuevo. Ver
// src/cabrillo/CREDITOS.md.

import { bl } from '../geo.js';

/**
 * @param {{titulo: HTMLElement, sub: HTMLElement}} els
 * @param {ReturnType<import('../motor.js').crearAnalizador>} motor
 */
export function montar(els, motor) {
    function actualizar() {
        const { hdr, D, bands, bad } = motor.modelo;
        els.titulo.textContent = (hdr.CALLSIGN || '?') + ' · ' + (hdr.CONTEST || 'Cabrillo');
        els.sub.textContent =
            D.length.toLocaleString('es') + ' QSO · ' + bands.map(bl).join(', ') + ' · UTC · bloques de 10 min' +
            (bad ? ' · ' + bad + ' QSO omitidos (sin prefijo o fecha reconocible)' : '');
    }
    actualizar(); // el encabezado no cambia con cur/bf, no hace falta motor.subscribe
    return { actualizar };
}
